<template>
  <div class="position-relative d-none d-lg-block w-100">
    <div class="cl-search">
      <div class="form" :class="{'cl-search-focused':isActive}">
        <div id="search" class="inner-form" :class="{'is-focus':isFocus}">
          <div class="input-field first-wrap">
            <div class="svg-wrapper">
              <v-icon icon="$magnify" ></v-icon>
            </div>
            <input type="text"
                   @click="showSearchContainer"
                   @keydown.enter="showResultPage"
                   @input="handleSearch"
                   v-model="searchInput"
                   name="search"
                   placeholder="چی میخوای یاد بگیری؟"
                   autocomplete="off"
                   class="cl-search-input"
                   @focus="isFocus = true" @blur="isFocus = false" style=""/>
          </div>
        </div>
      </div>
    </div>

    <div class="search-suggest-container vs-con-loading__container" v-show="isActive" ref="searchBoxContainer">
      <ClLoadingOverlay v-if="isLoading" v-model="isLoading"/>
      <div v-if="hasSearchResult" class="search-suggest" @click="deactivateOverly">
        <h2 v-if="searchResult.teachers.length">اساتید</h2>
        <router-link v-for="(teacher,index) in searchResult.teachers" :key="index"
                     :to="{name:'professor', params:{'userId': teacher.id }}">
          <img :src="menuProfImage(teacher.img)">
          <span>{{ teacher.name }}</span>
        </router-link>
        <h2 v-if="searchResult.courses.length">دوره‌ها</h2>
        <router-link v-for="(course,index) in searchResult.courses" :key="index" :to="getLink(course)">
          <img :src="menuProductImage(course.img)">
          <span>{{ course.name }}</span>
        </router-link>
      </div>
      <div v-else class="mx-2 border-0">
        <span class="no-result">جستجو برای عبارت «{{ searchInput }}» نتیجه ای نداشت.</span>
      </div>
    </div>

    <div class="" :class="{'search-suggest-overlay':isActive}" @click="deactivateOverly"></div>
    <!--    <a class="" :class="{'search-suggest-overlay':isActive}" :style="{top:topOffset}" @click="deactivateOverly"></a>-->
  </div>
</template>

<script>
import ClLoadingOverlay from "@/components/base/ClLoadingOverlay.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
export default {
  components: {ClLoadingOverlay},
  data() {
    return {
      isActive: false,
      searchInput: '',
      productSearchRepo: RepositoryFactory.get('ProductSearch'),
      searchResult: {},
      config: '',
      isLoading: false,
      isFocus: false,
      topOffset: '0px',
      isSpinnerActive: false,
      setZIndex: '1010',
    }
  },
  methods: {
    getLink(item) {
      let link = ''
      if (
        item.product_type_id !== 15 &&
        item.product_type_id !== 12 &&
        item.product_type_id !== 10
      ) {
        link = {
          name: 'course',
          params: {
            courseId: item.product_id,
          },
        }
      } else if (item.product_type_id === 15)
        link = { name: 'customPackage', params: { courseId: item.product_id } }
      else {
        link = { name: 'package', params: { courseId: item.product_id } }
      }
      return link
    },
    showSearchContainer() {
      if (this.searchInput.length > 2) {
        this.isActive = true;
        document.body.style.overflow = "hidden";
      }
    },
    async handleSearch() {
      // console.log(this.searchResult)
      if (this.searchInput.length > 2) {
        this.isLoading = true;
        this.isActive = true;
        document.body.style.overflow = "hidden";
        try {
          const {data} = await this.productSearchRepo.send({'keyword': this.searchInput});
          this.searchResult = data;
          this.isLoading = false
        } catch (error) {
          console.log(error)
        }
      } else {
        document.body.style.overflow = null;
        this.isActive = false;
      }
    },
    clearSearchInput() {
      this.searchInput = '';
      this.isActive = false;
      document.body.style.overflow = null;
    },
    deactivateOverly() {
      this.isActive = false;
      document.body.style.overflow = null;
    },
    menuProductImage(img) {
      return new URL(this.$storeFourBaseUrl + '/filepond/product/' + img, import.meta.url)
    },
    menuProfImage(img) {
      return new URL(this.$storeFourBaseUrl + '/filepond/profile/' + img, import.meta.url)
    },
    showResultPage() {
      if (this.searchInput.length > 2) {
        this.isActive = false;
        this.$router.push({name: 'search', params: {term: this.searchInput}});
      }
    }
  },
  computed: {
    hasSearchResult() {
      return this.searchResult.courses?.length || this.searchResult.teachers?.length || this.searchResult.packages?.length
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}

.cl-search-focused {
  z-index: 1001;
}

.cl-search-input {
  border: none !important;
  outline: none !important;
}
</style>
